//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "NewDIP",
  data: function() {
    return {
      newData: {},
      id: '',
      positionOption: [{label:'-', value: null}],
      unitOption: [],
    };
  },
  mounted() {
    this.id = this.$route.params.id
    if(this.id != -1){
      this.$http.get('/position_byid/'+this.id, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.newData = result.data
      })
    }
    this.$http.get('/admin_position', {
      headers: { Authorization: "Bearer " + token}
    })
    .then (result => {
      for(var i=0; i<result.data.length;i++){
        this.positionOption.push({label:result.data[i].position, value: result.data[i].id})
      }
    })
    this.$http.get('/work_unit', {
      headers: { Authorization: "Bearer " + token}
    })
    .then (result => {
      for(var i=0; i<result.data.length;i++){
        this.unitOption.push({label:result.data[i].name, value: result.data[i].id})
      }
    })
  },
  methods: {
    onSubmit(){
      if(this.id == '-1'){
        this.newData.createdBy = this.$store.state.currentAdmin.username
        this.$http.post('/new_position/', this.newData, {
          headers: { Authorization: "Bearer " + token}
        })
        .then (result => {
          this.$router.push('jabatan')
        })
      }
      else{
        this.newData.updatedBy = this.$store.state.currentAdmin.username
        this.newData.updatedDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
        this.$http.put('/update_position/' + this.id, this.newData, {
          headers: { Authorization: "Bearer " + token}
        })
        .then (result => {
          this.$router.push('jabatan')
        })
      }
    },
  },
};
